import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, Typography, Button } from "@material-ui/core";
import Popup from "../../../components/customHelpers/Popup";
import ChangeCustomer from "../../../components/forms/customers";
import Notification from "../../../components/customHelpers/Notification";
import Notify from "../../../components/customHelpers/Notify";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    padding: theme.spacing(1),
    maxHeight: 330,
    maxWidth: 360,
  },
  title: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  propertyContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    "& > :last-child": {
      marginLeft: theme.spacing(3), // Add this line to add margin to the value
    },
  },
  label: {
    fontWeight: "bold",
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(2),
  },
  value: {
    color: theme.palette.text.primary,
  },
  button: {
    marginTop: theme.spacing(2),
    textTransform: "capitalize",
  },
}));

const CustomerDetails = ({ product, title, getOrderData, change, id }) => {
  const classes = useStyles();
  const [openPopupChange, setOpenPopupChange] = useState(false);
  const { NotifyMessage, notify, setNotify } = Notify();
  
  return (
    <Card className={classes.root}>
      <CardContent>
        {product.customer && (
          <>
            <Typography variant="h6" className={classes.title}>
              {title ? title : "Bill To"}
            </Typography>

            <div className={classes.propertyContainer}>
              <Typography className={classes.label}>Name</Typography>
              <Typography className={classes.value}>
                {product?.customer.fullName}
              </Typography>
            </div>
            <div className={classes.propertyContainer}>
              <Typography className={classes.label}>Email</Typography>
              <Typography className={classes.value}>
                {product?.customer?.email}
              </Typography>
            </div>
            <div className={classes.propertyContainer}>
              <Typography className={classes.label}>Phone</Typography>
              <Typography className={classes.value}>
                {product?.customer?.phoneNo}
              </Typography>
            </div>
            <div className={classes.propertyContainer}>
              <Typography className={classes.label}>Location</Typography>
              <Typography className={classes.value}>
                {product?.customer?.location}
              </Typography>
            </div>
            <div className={classes.propertyContainer}>
              <Typography className={classes.label}>Address</Typography>
              <Typography className={classes.value}>
                {product?.customer?.address}
              </Typography>
            </div>
            <div className={classes.propertyContainer}>
              <Typography className={classes.label}>Contact</Typography>
              <Typography className={classes.value}>
                {product?.customer?.contact}
              </Typography>
            </div>
          </>
        )}
        {change && (
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => {
              setOpenPopupChange(true);
            }}
          >
            Change Customer
          </Button>
        )}
      </CardContent>
      <Popup
        title="Change Customer"
        openPopup={openPopupChange}
        setOpenPopup={setOpenPopupChange}
      >
        <ChangeCustomer
          NotifyMessage={NotifyMessage}
          id={id}
          setOpenPopupBulkSave={setOpenPopupChange}
          getOrderData={getOrderData}
          setOpenPopup={setOpenPopupChange}
        />
      </Popup>
      <Notification notify={notify} setNotify={setNotify} />
    </Card>
  );
};

export default CustomerDetails;
